import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { DialogService } from '../../dialog/dialog.service';
import { dateAsString } from '../../shared/date.helper';
import { AnswerService } from '../answer.service';
import { AnswerStatus } from '../answer.status';

@Component({
  selector: 'app-answer-invalid-form',
  templateUrl: './answer-invalid-form.component.html',
  styleUrls: ['./answer-invalid-form.component.scss'],
})
export class AnswerInvalidFormComponent implements OnInit {
  constructor(
    public answerService: AnswerService,
    public route: ActivatedRoute,
    private fb: UntypedFormBuilder,
    private toastr: ToastrService,
    private dialog: DialogService,
  ) {
    this.form = this.fb.group({
      answer: ['', [Validators.required]],
    });
  }
  get answer() {
    return this._answer;
  }

  @Input() set answer(a) {
    this._answer = a;

    this.isCommentsCollapsed = true;
    this.isFlagsCollapsed = true;
    this.editing = false;

    if (this.answer) {
      this.form.get('answer').setValue(this.answer.answer);
    } else {
      this.form.get('answer').setValue('');
    }
  }

  AnswerStatus = AnswerStatus;
  dateAsString = dateAsString;

  _answer;

  @Input() question;
  @Input() readOnly = false;
  @Output() statusChange = new EventEmitter();
  @Output() setPictures = new EventEmitter();

  form: UntypedFormGroup;

  isCommentsCollapsed;
  isFlagsCollapsed;
  editing;

  fileToUpload: File;

  ngOnInit() {}

  async addFlag(text) {
    const answer = await this.answerService.addFlag(this.answer.id, { text });
    this.answer.flags = answer.flags;
    this.toastr.success('Flag added!');
  }

  async removeFlag(index) {
    this.dialog.confirm().show({
      message: `Do you really want to remove the Flag?`,
      confirmed: async () => {
        const answer = await this.answerService.removeFlag(this.answer.id, index);
        this.answer.flags = answer.flags;
        this.toastr.success('Flag removed!');
      },
    });
  }

  async addComment(text) {
    const answer = await this.answerService.addComment(this.answer.id, { text });
    this.answer.comments = answer.comments;
    this.toastr.success('Comment added!');
  }

  async removeComment(index) {
    this.dialog.confirm().show({
      message: `Do you really want to remove the Comment?`,
      confirmed: async () => {
        const answer = await this.answerService.removeComment(this.answer.id, index);
        this.answer.comments = answer.comments;
        this.toastr.success('Comment removed!');
      },
    });
  }

  formattedDateTime(date) {
    const obj = new Date(date);
    return `${obj.getMonth() + 1}/${obj.getDate()}/${obj.getFullYear()} ${obj.getHours() < 10 ? '0' : ''}${obj.getHours()}:${obj.getMinutes() < 10 ? '0' : ''}${obj.getMinutes()}`;
  }

  accept() {
    this.statusChange.emit({ answer: this.answer, status: AnswerStatus.ACCEPTED });
  }

  reject() {
    this.statusChange.emit({ answer: this.answer, status: AnswerStatus.REJECTED });
  }

  showPictures() {
    this.setPictures.emit(this.answer);
  }

  getValidationClass(field: string) {
    const control = this.form.get(field);
    return {
      'is-valid': control.valid && (control.dirty || control.touched),
      'is-invalid': control.invalid && (control.dirty || control.touched),
    };
  }

  async changeAnswer() {
    if (this.form.valid && this.answer) {
      this.answer.answer = this.form.get('answer').value;
      this.editing = false;
      await this.answerService.changeAnswer(this.answer.id, this.answer.answer);
      this.toastr.success('Answer changed!');
    }
  }

  setUploadFile(files: FileList) {
    this.fileToUpload = files.item(0);
  }

  async uploadFile() {
    const savedAnswer = await this.answerService.addPicture(this.answer, this.fileToUpload as any);
    this.answer.pictures = savedAnswer.pictures;
  }

  isPictureOrLocationOnly(question) {
    return question && (question.type === 'picture-only' || question.type === 'location-only');
  }
}
